import { app } from '../../../../app';

app.component('manageAccountTabs', {
    templateUrl: require('./manage-account-tabs.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/manage-account-tabs.component.js